export enum ItemType {
	APPOINTMENT = 'appointment',
	MEDICAL_EVALUATION = 'medicalEvaluation',
	OTHER_CONSULTATION = 'otherConsultation',
	LABORATORY_EXAMINATION = 'laboratoryExamination',
	EDUCATION_MATERIAL = 'educationMaterial',
	MONITORING = 'monitoring',
	DIAGNOSTIC_IMAGING = 'diagnosticImaging',
	VACCINATION = 'vaccination',
	ELECTRONIC_PRESCRIPTION = 'electronicPrescription',
}
